import { ResponseCode } from "@app/constants/Common";
import { alertMessage, showMessage } from "@app/constants/Messages";
import { optionsToString } from "@app/utils/CommonUtils";
import { updateContactPointDetail } from "@app/services/CandidateService";
import { pipelineOptionsToString } from "@pages/dvtjcuv/common/PipelineUtil";
import InputCddGPEmpDiscussionContent from "@pages/dvtjcuv/rundvtjcuv/connectcddemp/InputCddGPEmpDiscussionContent";
import { requestSaveDVTJCUVPipeline } from "@pages/dvtjcuv/service/DVTJCUVPipelineService";
import React, { useEffect, useRef, useState } from 'react';
import { Modal } from 'react-bootstrap';
import Button from 'react-bootstrap/Button';

export const CddGPEmpDiscussionMode = {
    DEFAULT: 1,
    PAYMENT_AND_WARRANTY: 2
}

// These two fields persist to ContactPoint (separate endpoint) — never include them in the pipeline POST body.
const CONTACT_POINT_FIELD_KEYS = ['candidate_receive_request', 'cdd_receiver_category'];

const InputCddGPEmpDiscussionModal = (props) => {
    const [pipeline, setPipeline] = useState({});
    const [isAddMode, setAddMode] = useState(true)
    const originalContactPointRef = useRef({ candidate_receive_request: '', cdd_receiver_category: '' });

    const {pipelineInfo, mode, isShow, onClose} = props

    useEffect(() => {
        if (pipelineInfo) {
            setPipeline(pipelineInfo)
            setAddMode(!pipelineInfo.id)
        } else {
            setPipeline({})
            setAddMode(true)
        }
        originalContactPointRef.current = { candidate_receive_request: '', cdd_receiver_category: '' };
    }, [isShow, pipelineInfo]);

    const onOriginalContactPointLoaded = (original) => {
        originalContactPointRef.current = original;
    };

    const buildPipelineBody = () => {
        const body = pipelineOptionsToString(pipeline);
        CONTACT_POINT_FIELD_KEYS.forEach((k) => { delete body[k]; });
        body.id = '';
        return body;
    };

    const buildContactPointBodyIfChanged = () => {
        if (!pipeline.cdd_receiver_id) return null;
        const currentReceiveRequest = optionsToString(pipeline.candidate_receive_request, true);
        const currentCategory = optionsToString(pipeline.cdd_receiver_category, true);
        const original = originalContactPointRef.current;
        const changed = (currentReceiveRequest || '') !== (original.candidate_receive_request || '')
                     || (currentCategory || '') !== (original.cdd_receiver_category || '');
        if (!changed) return null;
        return {
            candidate_id: pipeline.cdd_receiver_id,
            contact_points: {
                candidate_receive_request: currentReceiveRequest,
                cdd_receiver_category: currentCategory,
            },
        };
    };

    const onUpdatePipeLineInfo = () => {
        if (!pipeline.cdd_id) {
            showMessage("Vui lòng nhập Cdd ID")
            return;
        }

        const pipelineBody = buildPipelineBody();
        const cpBody = buildContactPointBodyIfChanged();

        const calls = [requestSaveDVTJCUVPipeline(pipelineBody)];
        if (cpBody) {
            calls.push(updateContactPointDetail(cpBody));
        }

        Promise.all(calls)
            .then((responses) => {
                const fail = responses.find((r) => r?.sts_code !== ResponseCode.SUCCESS);
                if (fail) {
                    alertMessage(fail.sts_code);
                    return;
                }
                onClose(true);
            })
            .catch((error) => {
                console.log(`Error:${JSON.stringify(error)}`);
            });
    }

    const onChangeInputItem = (values, column) => {
        pipeline[column.key] = values
    }

    return (
        <>
            <Modal show={isShow}
                   fullscreen style={{zIndex: 3002}}
                   onHide={() => onClose()}
                   animation={false}>
                <Modal.Header>
                    <Modal.Title>
                        {'Nhập thông tin GP-Emp-Discussion'}
                    </Modal.Title>
                    <Button variant='secondary' onClick={() => onClose()}>
                        Close
                    </Button>
                </Modal.Header>
                <form onSubmit={(event) => {
                    event.preventDefault();
                    onUpdatePipeLineInfo()
                }}>
                    <Modal.Body>
                        <InputCddGPEmpDiscussionContent
                            mode={mode}
                            onChangeInputItem={onChangeInputItem}
                            onOriginalContactPointLoaded={onOriginalContactPointLoaded}
                            pipeLineInfo={pipeline}
                        />
                    </Modal.Body>
                    <Modal.Footer>
                        <Button type='submit'
                                className='btn btn-primary'
                                >
                            <i className='fas fa-save mr-2'/>
                            Save
                        </Button>
                    </Modal.Footer>
                </form>
            </Modal>
        </>
    )
}

export default InputCddGPEmpDiscussionModal;
